/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import {toast} from 'react-toastify';

const triggerToast = (message, type = 'error', properties = {}) => {
  toast(message, {
    autoClose: 5000,
    closeButton: true,
    type,
    pauseOnHover: true,
    ...properties,
  });
};

// Update existing toast
const updateToast = (toastId, message, type = 'success', properties = {}) => {
  toast.update(toastId, {
    render: message,
    type,
    isLoading: false,
    autoClose: 5000,
    closeButton: true,
    pauseOnHover: true,
    ...properties,
  });
};

// Dismiss toast
const dismissToast = (toastId) => {
  toast.dismiss(toastId);
};

export default triggerToast;

export {updateToast, dismissToast};
